import * as React from 'react'
const CameraIcon = ({ colorA = "#d7dae0" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path d="M10 7a4 4 0 104 4 4 4 0 00-4-4zm0 7a3 3 0 113-3 3 3 0 01-3 3z" className="-primary-color" fill="#a5aab8" fillRule="evenodd"/>
      <path d="M15.5 5h-1.69l-.58-1.17A1.49 1.49 0 0011.89 3H8.12a1.51 1.51 0 00-1.34.83L6.19 5H4.5A2.5 2.5 0 002 7.5v8A2.5 2.5 0 004.5 18h11a2.49 2.49 0 002.5-2.5v-8A2.49 2.49 0 0015.5 5zM17 15.5a1.5 1.5 0 01-1.5 1.5h-11A1.5 1.5 0 013 15.5v-8A1.5 1.5 0 014.5 6h2a.51.51 0 00.5-.28l.73-1.44A.49.49 0 018.12 4h3.77a.51.51 0 01.45.28l.72 1.44a.5.5 0 00.45.28h2A1.5 1.5 0 0117 7.5z" className="-secondary-color" fill="#d7dae0" fillRule="evenodd"/>
    </svg>
    
  )
}

export default CameraIcon